<template>
  <div style="background-color:white;height: 100%;width: 100%;">
    <el-row>
      <el-col :span="8">
        <div class="down-tree" style="height:600px;border:1px solid #000">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
          <el-tree :data="data" ref="tree" :props="defaultProps" class="filter-tree" @node-click="handleNodeClick"
            :default-expanded-keys="defaultExpandIds" node-key="id" :filter-node-method="filterNode"
            @node-expand="handleNodeExpand" @node-collapse="handleNodeCollapse">
          </el-tree>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="margin-top:50px;margin-left:50px;">
          <el-form label-width="80px" :model="form">
            <el-form-item label="当前选中">
              <el-input v-model.trim="form.deviceTypeName" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="设备名称">
              <el-input v-model.trim="form.newName"></el-input>
            </el-form-item>
            <el-form-item label="管理方式">
              <el-select v-model="form.glfs" style="width:100%" clearable>
                <el-option v-for="item in glfs" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <!-- <el-input v-model.trim="form.glfs"></el-input>  -->
            </el-form-item>
            <el-form-item label="管理编号">
              <el-input v-model.trim="form.glbhqz"></el-input>
            </el-form-item>
            <el-button class="flter-item" v-preventReClick type="primary" @click="handleCreate"
              icon="el-icon-plus">添加大类</el-button>
            <el-button class="flter-item" v-preventReClick type="primary" @click="handleCreate1"
              icon="el-icon-plus">增加子类</el-button>
            <el-button class="flter-item" v-preventReClick type="primary" @click="handleCreate2"
              icon="el-icon-edit">修改选中类</el-button>
            <el-button class="flter-item" v-preventReClick type="danger" @click="handleCreate3"
              icon="el-icon-delete">删除</el-button>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { selectTreeDeviceType, addDeviceType, addBigType, updateBigType, deleteDeviceType } from "../../api/api";
export default {
  name: "DeviceSort",
  data() {
    return {
      defaultExpandIds: [],
      data: [],
      defaultProps: {
        children: "deviceTypes",
        label: "deviceTypeName"
      },
      filterText: '',
      options: [],
      form: {
        id: "",
        deviceTypeName: "",
        pid: "",
        newName: "",
        glfs: "",
      },
      tableData: [],
      glfs: [{
        label: 'I',
        value: 'I',
      }, {
        label: 'II-1',
        value: 'II-1',
      }, {
        label: 'II-2',
        value: 'II-2',
      }, {
        label: 'II-3',
        value: 'II-3',
      }, {
        label: 'III',
        value: 'III',
      }],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) { // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      // 删除当前关闭的节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1)
        }
      })
      this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
    },
    removeChildrenIds(data) {
      const ts = this
      if (data.children) {
        data.children.forEach(function (item) {
          const index = ts.defaultExpandIds.indexOf(item.id)
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1)
          }
          ts.removeChildrenIds(item)
        })
      }
    },


    handleNodeClick(data) {
      this.form = data;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deviceTypeName.indexOf(value) !== -1;
    },
    //添加大类
    handleCreate() {
      var s = {
        deviceTypeName: this.form.newName,
        deviceTypeCode: this.form.deviceTypeCode,
        glbhqz: this.form.glbhqz,
        glfs: this.form.glfs
      };
      addBigType(s).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.form = {}
          this.findAll();
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //添加子类
    handleCreate1() {
      var s = {
        id: this.form.id,
        deviceTypeName: this.form.newName,
        deviceTypeCode: this.form.deviceTypeCode == null ? null : this.form.deviceTypeCode,
        glbhqz: this.form.glbhqz,
        pid: this.form.pid,
        glfs: this.form.glfs
      };
      addDeviceType(s).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "添加成功",
            type: "success"
          });

          this.findAll();
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //修改选中单位
    handleCreate2() {
      var s = {
        id: this.form.id,
        deviceTypeCode: this.form.deviceTypeCode,
        deviceTypeName: this.form.newName,
        glbhqz: this.form.glbhqz,
        pid: this.form.pid,
        glfs: this.form.glfs
      };
      updateBigType(s).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.form = {}
          this.findAll();
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //删除选中分类
    handleCreate3() {
      this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDeviceType(this.form.id).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.form = {}
            this.findAll();
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    findAll() {
      selectTreeDeviceType().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.data = data;
        }
      });
    }
  },
  created() {
    this.findAll();
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.down-tree {
  display: block;

  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/SystemSettings/DeviceSort.vue